export const SUPPORTED_FILE_TYPES_MESSAGE =
  'Images (JPG, PNG, WebP, GIF), Documents (PDF, DOCX, XLSX, PPTX, TXT, RTF, XML, CSV), ZIP, MP4';

export const SUPPORTED_MIME_TYPES = {
  // Images
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/webp': ['.webp'],
  'image/gif': ['.gif'],
  // Documents
  'application/pdf': ['.pdf'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
  'text/plain': ['.txt'],
  'application/rtf': ['.rtf'],
  'text/xml': ['.xml'],
  'text/csv': ['.csv'],
  // Archives
  'application/zip': ['.zip'],
  // Video
  'video/mp4': ['.mp4'],
};
